import { Link, useLocation } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import $ from "jquery";
import "select2/dist/css/select2.min.css";
import "select2/dist/js/select2.full.min.js";
import "select2";
import { useSchoolDetailsContext } from "../context/SchoolDetailsContext";
import { useNavigate } from "react-router-dom";
import { useAllDataContext } from "../context/AllDataContext";
import { combineDataForSearch } from "../pages/SearchPage";
import MobileSearch from "./MobileSearch";

const HeaderOne = () => {
  let { pathname } = useLocation();
  const [scroll, setScroll] = useState(false);
  const [isMenuActive, setIsMenuActive] = useState(false);
  const { schoolDetailsData } = useSchoolDetailsContext();
  const formRef = useRef(null);
  const [isInputFocused, setIsInputFocused] = useState(false);
  const location = useLocation();

  useEffect(() => {
    function handleClickOutside(event) {
      if (formRef.current && !formRef.current.contains(event.target)) {
        setIsInputFocused(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const [searchQuery, setSearchQuery] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const { allData } = useAllDataContext();
  const navigate = useNavigate();
  const staticDataMap = {
    email: schoolDetailsData[0]?.attributes?.Email,
    address: schoolDetailsData[0]?.attributes?.Address,
    phone: `${schoolDetailsData[0]?.attributes?.Phone_Number1 || ""}, ${
      schoolDetailsData[0]?.attributes?.Phone_Number2 || ""
    }`,
  };

  const staticLabelMap = {
    email: "Email",
    address: "Address",
    phone: "Phone Number",
    admission: "Admission Enquiry",
  };
  const staticKeys = ["email", "address", "phone", "admission"];
  const lowerQuery = searchQuery.toLowerCase();

  const matchedKey = staticKeys.find(
    (key) =>
      key.includes(lowerQuery) ||
      staticLabelMap[key].toLowerCase().includes(lowerQuery),
  );
  const isStaticMatch = Boolean(matchedKey);
  const calendarData = allData.calendarData;

  useEffect(() => {
    if (searchQuery.trim().length === 0) {
      setSuggestions([]);
      return;
    }

    const lowerQuery = searchQuery.toLowerCase();
    const filtered = combineDataForSearch(allData).filter((item) =>
      Object.values(item).some(
        (val) =>
          typeof val === "string" && val.toLowerCase().includes(lowerQuery),
      ),
    );

    setSuggestions(filtered);
  }, [searchQuery, allData]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/search?query=${encodeURIComponent(searchQuery.trim())}`);
      setSuggestions([]);
    }
  };

  const handleSuggestionClick = (section, path, id) => {
    // setSearchQuery(title);
    // navigate(`/search?query=${encodeURIComponent(title)}`);
    // setSuggestions([]);
    if (
      section === "studentlife" ||
      section === "faculty" ||
      section === "gallery" ||
      section === "tiles" ||
      section === "objective"
    ) {
      navigate(path, {
        state: { section: `${section}${id}` },
      });
    } else {
      navigate(path, {
        state: { section: section },
      });
    }
    setSuggestions([]);
    setSearchQuery("");
  };

  useEffect(() => {
    if (typeof window !== "undefined") {
      import("select2").then(() => {
        const selectElement = $(".js-example-basic-single");
        if (selectElement.length > 0) {
          selectElement.select2();
        }
      });
    }

    window.onscroll = () => {
      if (window.pageYOffset < 150) {
        setScroll(false);
      } else if (window.pageYOffset > 150) {
        setScroll(true);
      }
      return () => (window.onscroll = null);
    };
  }, []);

  const toggleMenu = () => {
    setIsMenuActive(!isMenuActive);
    if (!isMenuActive) {
      document.body.classList.add("scroll-hide-sm");
    } else {
      document.body.classList.remove("scroll-hide-sm");
    }
  };

  const closeMenu = () => {
    setIsMenuActive(false);
    document.body.classList.remove("scroll-hide-sm");
  };

  const [activeSubmenu, setActiveSubmenu] = useState(null);
  const [windowWidth, setWindowWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 0,
  );

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleSubmenuClick = (index) => {
    if (windowWidth < 992) {
      setActiveSubmenu((prevIndex) => (prevIndex === index ? null : index));
    }
  };

  const menuItems = [
    { to: "/", label: "Home" },
    // {
    //   label: "Home",
    //   links: [
    //     { to: "/", label: "Home LMS" },
    //     { to: "/index-2", label: "Home Online Course" },
    //     { to: "/index-3", label: "Home University" },
    //     { to: "/index-4", label: "Home Tutor" },
    //   ],
    // },
    {
      label: "Academic",
      links: [
        { to: "/programs", label: "Programs" },
        {
          to:
            calendarData[0]?.calendar[0]?.media?.url &&
            `${process.env.REACT_APP_cmsUrl}${calendarData[0]?.calendar[0]?.media?.url}`,
          label: "Calendar",
        },
        // { to: "/faculties", label: "Faculties" },
        // { to: "/course-details", label: "Course Details" },
        // { to: "/lesson-details", label: "Lesson Details" },
      ],
    },
    {
      label: "Student Life",
      links: [
        { to: "/facilities", label: "Facilities" },
        { to: "/activities", label: "Activities" },
        // { to: "/about-three", label: "About Three" },
        // { to: "/about-four", label: "About Four" },
        // { to: "/product", label: "Product" },
        // { to: "/product-details", label: "Product Details" },
        // { to: "/cart", label: "Cart" },
        // { to: "/checkout", label: "Checkout" },
        // { to: "/pricing-plan", label: "Pricing Plan" },
        // { to: "/instructor", label: "Instructor" },
        // { to: "/instructor-two", label: "Instructor Two" },
        // { to: "/instructor-details", label: "Instructor Details" },
        // { to: "/tutor", label: "Premium Tutors" },
        // { to: "/tutor-details", label: "Premium Tutors Details" },
        // { to: "/faq", label: "FAQ" },
        // { to: "/tuition-jobs", label: "Tuition Jobs" },
        // { to: "/events", label: "Events" },
        // { to: "/event-details", label: "Event Details" },
        // { to: "/apply-admission", label: "Apply Admission" },
        // { to: "/gallery", label: "Gallery" },
        // { to: "/privacy-policy", label: "Privacy Policy" },
        // { to: "/favorite-course", label: "Favorite Course" },
        // { to: "/find-tutors", label: "Find Best Tutors" },
        // { to: "/book-online-class", label: "Book Online Class" },
      ],
    },

    // {
    //   label: "Blog",
    //   links: [
    //     { to: "/blog", label: "Blog Grid" },
    //     { to: "/blog-list", label: "Blog List" },
    //     { to: "/blog-classic", label: "Blog Classic" },
    //     { to: "/blog-details", label: "Blog Details" },
    //   ],
    // },
    { to: "/gallery", label: "Gallery", sublink: "/gallery/gallery-view" },
    { to: "/ega", label: "EGA" },
    { to: "/contact", label: "Contact" },
    { to: "/admission", label: "Admission" },
  ];

  return (
    <>
      <div className={`side-overlay ${isMenuActive ? "show" : ""}`}></div>
      <header className={`header ${scroll ? "fixed-header" : ""}`}>
        {/* <header className={`header`}> */}
        <div className="container container--xl">
          <nav className="header-inner flex-between gap-8">
            {/* <div className='header-content-wrapper flex-align flex-grow-1'> */}
            {/* Logo Start */}
            {scroll ? (
              <Link to="/">
                <div className="logo">
                  <img
                    src={
                      schoolDetailsData[0]?.attributes?.Footer_Logo?.data
                        ?.attributes?.url &&
                      `${process.env.REACT_APP_strapiUrl}${schoolDetailsData[0]?.attributes?.Footer_Logo?.data?.attributes?.url}`
                    }
                    alt="Logo"
                  />
                </div>
              </Link>
            ) : (
              <Link to="/">
                <div className="logo">
                  <img
                    src={
                      schoolDetailsData[0]?.attributes?.Logo?.data?.attributes
                        ?.url &&
                      `${process.env.REACT_APP_strapiUrl}${schoolDetailsData[0]?.attributes?.Logo?.data?.attributes?.url}`
                    }
                    alt="Logo"
                  />
                </div>
              </Link>
            )}
            {/* Logo End  */}
            {/* Select Start */}
            {/* <div className='d-sm-block d-none'>
                <div className='header-select border border-neutral-30 bg-main-25 rounded-pill position-relative'>
                  <span className='select-icon position-absolute top-50 translate-middle-y inset-inline-start-0 z-1 ms-lg-4 ms-12 text-xl pointer-event-none d-flex'>
                    <i className='ph-bold ph-squares-four' />
                  </span>
                  <select
                    className='js-example-basic-single border-0'
                    name='state'
                    defaultValue='categories'
                  >
                    <option value={"Categories"}>Categories</option>
                    <option value={"Design"}>Design</option>
                    <option value={"Development"}>Development</option>
                    <option value={"Architecture"}>Architecture</option>
                    <option value={"Life Style"}>Life Style</option>
                    <option value={"Data Science"}>Data Science</option>
                    <option value={"Marketing"}>Marketing</option>
                    <option value={"Music"}>Music</option>
                    <option value={"Typography"}>Typography</option>
                    <option value={"Finance"}>Finance</option>
                    <option value={"Motivation"}>Motivation</option>
                  </select>
                </div>
              </div> */}
            {/* Select End */}
            {/* Menu Start  */}
            <div className="header-menu d-lg-block d-none">
              <ul className="nav-menu flex-align">
                {menuItems.map((item, index) =>
                  item.links ? (
                    <li
                      key={`menu-item-${index}`}
                      className="nav-menu__item has-submenu"
                    >
                      <span
                        to="#"
                        className={`nav-menu__link ${scroll && "text-white"}`}
                      >
                        {item.label}
                      </span>
                      <ul
                        className={`nav-submenu scroll-sm ${
                          scroll && "drop-fixed-header"
                        }`}
                      >
                        {item.links.map((link, linkIndex) => (
                          <li
                            key={`submenu-item-${linkIndex}`}
                            className={`nav-submenu__item ${
                              pathname === link.to && "activePage"
                            }`}
                          >
                            {link.label === "Calendar" &&
                            calendarData.length === 0 ? (
                              <span
                                className={`nav-submenu__link disabled-link ${
                                  scroll && "text-white"
                                }`}
                                style={{ pointerEvents: "none", opacity: 0.5 }}
                              >
                                {link.label}
                              </span>
                            ) : link.to.startsWith("http") ? (
                              <a
                                href={link.to}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={`nav-submenu__link hover-bg-main-700 ${
                                  scroll && "text-white"
                                }`}
                              >
                                {link.label}
                              </a>
                            ) : (
                              <Link
                                to={link.to}
                                className={`nav-submenu__link hover-bg-main-700 ${
                                  scroll && "text-white"
                                }`}
                              >
                                {link.label}
                              </Link>
                            )}
                          </li>
                        ))}
                      </ul>
                    </li>
                  ) : (
                    <li
                      key={`menu-contact-${index}`}
                      className={`nav-menu__item ${
                        (pathname === item.to ||
                          (item.sublink && pathname === item.sublink)) &&
                        "activePage"
                      }`}
                    >
                      <Link
                        to={item.to}
                        className={`nav-menu__link ${scroll && "text-white"}`}
                      >
                        {item.label}
                      </Link>
                    </li>
                  ),
                )}
              </ul>
            </div>
            {/* Menu End  */}
            {/* </div> */}
            {/* Header Right start */}
            <div className="header-right flex-align">
              <form
                ref={formRef}
                onSubmit={handleSubmit}
                className="search-form position-relative d-xl-block d-none"
              >
                <input
                  type="text"
                  className="common-input rounded-pill bg-main-25 pe-48 border-neutral-30"
                  placeholder="Search..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  onFocus={() => setIsInputFocused(true)}
                  style={{ padding: "10px 18px" }}
                />
                <button
                  type="submit"
                  className="w-32 h-32 bg-main-600 hover-bg-main-700 rounded-circle flex-center text-md text-white position-absolute top-50 translate-middle-y inset-inline-end-0 me-8"
                >
                  <i className="ph-bold ph-magnifying-glass" />
                </button>
                {(suggestions.length > 0 || isStaticMatch) &&
                  searchQuery !== "" &&
                  isInputFocused && (
                    <ul className="suggestion-dropdown position-absolute bg-white border rounded shadow mt-2 z-10 dropdown-width">
                      {isStaticMatch && (
                        <li
                          onClick={() => {
                            handleSuggestionClick(
                              matchedKey === "admission"
                                ? "admissioninfo"
                                : "contactinfo",
                              matchedKey === "admission"
                                ? "/admission"
                                : location.pathname,
                            );
                            setSearchQuery("");
                          }}
                          className="px-3 py-2 cursor-pointer hover-bg-main-50"
                          style={{ cursor: "pointer" }}
                        >
                          <h5 className="wow bounceInRight mb-0 text-ellipsis">
                            {staticLabelMap[matchedKey] || ""}
                          </h5>
                          <p className="text-neutral-500 text-line-2 wow bounceInUp text-ellipsis">
                            {staticDataMap[matchedKey] || ""}
                          </p>
                        </li>
                      )}
                      {suggestions.map((item, index) => (
                        // <li
                        //   key={index}
                        //   onClick={() =>
                        //     handleSuggestionClick(item.Title || item.Name || "")
                        //   }
                        //   className="px-3 py-2 cursor-pointer hover-bg-main-50"
                        //   style={{ cursor: "pointer" }}
                        // >
                        //   {item.Title || item.Name}
                        // </li>
                        <li
                          key={index}
                          onClick={() =>
                            handleSuggestionClick(
                              item.section,
                              item.path,
                              item.id,
                            )
                          }
                          className="px-3 py-2 cursor-pointer hover-bg-main-50"
                          style={{ cursor: "pointer" }}
                        >
                          {item.snippet && (
                            <div className="flex-align d-inline-flex gap-8 mb-16 wow bounceInDown">
                              <h6 className="text-main-600 mb-0 text-ellipsis">
                                {item.snippet}
                              </h6>
                            </div>
                          )}
                          {(item.title || item.name) && (
                            <h5 className="wow bounceInRight mb-0 text-ellipsis">
                              {item.title || item.name || ""}
                            </h5>
                          )}
                          {item.description && (
                            <p className="text-neutral-500 text-line-2 wow bounceInUp text-ellipsis">
                              {item.description
                                .replace(/<[^>]*>/g, "")
                                .replace(/[-*_]/g, "")}
                            </p>
                          )}
                          {(item.position || item.role) && (
                            <p className="text-neutral-500 text-line-2 wow bounceInUp text-ellipsis">
                              {item.position || item.role || ""}
                            </p>
                          )}
                          {item.email && (
                            <p className="text-neutral-500 text-line-2 wow bounceInUp text-ellipsis">
                              {item.email || ""}
                            </p>
                          )}
                          {item.phone_number && (
                            <p className="text-neutral-500 text-line-2 wow bounceInUp text-ellipsis">
                              {item.phone_number || ""}
                            </p>
                          )}
                        </li>
                      ))}
                    </ul>
                  )}
              </form>
              {/* <Link
                to='/sign-in'
                className='info-action w-52 h-52 bg-main-25 hover-bg-main-600 border border-neutral-30 rounded-circle flex-center text-2xl text-neutral-500 hover-text-white hover-border-main-600'
              >
                <i className='ph ph-user-circle' />
              </Link> */}
              <MobileSearch scroll={scroll} />
              <button
                type="button"
                className="toggle-mobileMenu d-lg-none text-neutral-200 flex-center"
                onClick={toggleMenu}
              >
                <i className={`ph ph-list ${scroll && "text-white"}`} />
              </button>
            </div>
            {/* Header Right End  */}
          </nav>
        </div>
      </header>
      <div
        className={`mobile-menu scroll-sm d-lg-none d-block ${
          isMenuActive ? "active" : ""
        }`}
      >
        <button type="button" className="close-button" onClick={closeMenu}>
          <i className="ph ph-x" />{" "}
        </button>
        <div className="mobile-menu__inner">
          <Link to="/" className="mobile-menu__logo">
            <img
              src={
                schoolDetailsData[0]?.attributes?.Logo?.data?.attributes?.url &&
                `${process.env.REACT_APP_strapiUrl}${schoolDetailsData[0]?.attributes?.Logo?.data?.attributes?.url}`
              }
              alt="Logo"
              style={{ maxWidth: "145px" }}
            />
          </Link>
          <div className="mobile-menu__menu">
            <ul className="nav-menu flex-align nav-menu--mobile">
              {menuItems.map((item, index) =>
                item.links ? (
                  <li
                    key={`menu-item-${index}`}
                    className={`nav-menu__item has-submenu ${
                      activeSubmenu === index ? "activePage" : ""
                    }`}
                    onClick={() => handleSubmenuClick(index)}
                  >
                    <span className="nav-menu__link">{item.label}</span>
                    <ul className={`nav-submenu scroll-sm`}>
                      {item.links.map((link, linkIndex) => (
                        <li
                          key={linkIndex}
                          className={`nav-submenu__item ${
                            pathname === link.to && "activePage"
                          }`}
                        >
                          {link.label === "Calendar" &&
                          calendarData.length === 0 ? (
                            <span
                              className={`nav-submenu__link disabled-link`}
                              style={{ pointerEvents: "none", opacity: 0.5 }}
                            >
                              {link.label}
                            </span>
                          ) : link.to.startsWith("http") ? (
                            <a
                              href={link.to}
                              target="_blank"
                              rel="noopener noreferrer"
                              className={`nav-submenu__link hover-bg-main-700`}
                            >
                              {link.label}
                            </a>
                          ) : (
                            <Link
                              to={link.to}
                              className={`nav-submenu__link hover-bg-main-700`}
                            >
                              {link.label}
                            </Link>
                          )}
                        </li>
                      ))}
                    </ul>
                  </li>
                ) : (
                  <li
                    className={`nav-menu__item ${
                      pathname === item.to && "activePage"
                    }`}
                    key={index}
                  >
                    <Link to={item.to} className="nav-menu__link">
                      {item.label}
                    </Link>
                  </li>
                ),
              )}
            </ul>
            {/* <div className="d-sm-none d-block mt-24">
              <div className="header-select mobile border border-neutral-30 bg-main-25 rounded-pill position-relative">
                <span className="select-icon position-absolute top-50 translate-middle-y inset-inline-start-0 z-1 ms-lg-4 ms-12 text-xl pointer-event-none d-flex">
                  <i className="ph-bold ph-squares-four" />
                </span>
                <select
                  className="js-example-basic-single border-0"
                  name="state"
                >
                  <option value={"Categories"}>Categories</option>
                  <option value={"Design"}>Design</option>
                  <option value={"Development"}>Development</option>
                  <option value={"Architecture"}>Architecture</option>
                  <option value={"Life Style"}>Life Style</option>
                  <option value={"Data Science"}>Data Science</option>
                  <option value={"Marketing"}>Marketing</option>
                  <option value={"Music"}>Music</option>
                  <option value={"Typography"}>Typography</option>
                  <option value={"Finance"}>Finance</option>
                  <option value={"Motivation"}>Motivation</option>
                </select>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default HeaderOne;

// import { Link, useLocation } from "react-router-dom";
// import { useEffect, useState } from "react";
// import $ from "jquery";
// import "select2/dist/css/select2.min.css";
// import "select2/dist/js/select2.full.min.js";
// import "select2";

// const HeaderOne = () => {
//   let { pathname } = useLocation();
//   const [scroll, setScroll] = useState(false);
//   const [isMenuActive, setIsMenuActive] = useState(false);

//   useEffect(() => {
//     if (typeof window !== "undefined") {
//       import("select2").then(() => {
//         const selectElement = $(".js-example-basic-single");
//         if (selectElement.length > 0) {
//           selectElement.select2(); // Initialize Select2
//         }
//       });
//     }

//     window.onscroll = () => {
//       if (window.pageYOffset < 150) {
//         setScroll(false);
//       } else if (window.pageYOffset > 150) {
//         setScroll(true);
//       }
//       return () => (window.onscroll = null);
//     };
//   }, []);

//   const toggleMenu = () => {
//     setIsMenuActive(!isMenuActive);
//     if (!isMenuActive) {
//       document.body.classList.add("scroll-hide-sm");
//     } else {
//       document.body.classList.remove("scroll-hide-sm");
//     }
//   };

//   const closeMenu = () => {
//     setIsMenuActive(false);
//     document.body.classList.remove("scroll-hide-sm");
//   };

//   const [activeSubmenu, setActiveSubmenu] = useState(null);
//   const [windowWidth, setWindowWidth] = useState(
//     typeof window !== "undefined" ? window.innerWidth : 0
//   );

//   useEffect(() => {
//     const handleResize = () => setWindowWidth(window.innerWidth);
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   const handleSubmenuClick = (index) => {
//     if (windowWidth < 992) {
//       setActiveSubmenu((prevIndex) => (prevIndex === index ? null : index));
//     }
//   };

//   const menuItems = [
//     {
//       label: "Home",
//       links: [
//         { to: "/", label: "Home LMS" },
//         { to: "/index-2", label: "Home Online Course" },
//         { to: "/index-3", label: "Home University" },
//         { to: "/index-4", label: "Home Tutor" },
//       ],
//     },
//     {
//       label: "Courses",
//       links: [
//         { to: "/course", label: "Course Grid View" },
//         { to: "/course-list-view", label: "Course List View" },
//         { to: "/course-details", label: "Course Details" },
//         { to: "/lesson-details", label: "Lesson Details" },
//       ],
//     },
//     {
//       label: "Pages",
//       links: [
//         { to: "/about", label: "About" },
//         { to: "/about-two", label: "About Two" },
//         { to: "/about-three", label: "About Three" },
//         { to: "/about-four", label: "About Four" },
//         { to: "/product", label: "Product" },
//         { to: "/product-details", label: "Product Details" },
//         { to: "/cart", label: "Cart" },
//         { to: "/checkout", label: "Checkout" },
//         { to: "/pricing-plan", label: "Pricing Plan" },
//         { to: "/instructor", label: "Instructor" },
//         { to: "/instructor-two", label: "Instructor Two" },
//         { to: "/instructor-details", label: "Instructor Details" },
//         { to: "/tutor", label: "Premium Tutors" },
//         { to: "/tutor-details", label: "Premium Tutors Details" },
//         { to: "/faq", label: "FAQ" },
//         { to: "/tuition-jobs", label: "Tuition Jobs" },
//         { to: "/events", label: "Events" },
//         { to: "/event-details", label: "Event Details" },
//         { to: "/apply-admission", label: "Apply Admission" },
//         { to: "/gallery", label: "Gallery" },
//         { to: "/privacy-policy", label: "Privacy Policy" },
//         { to: "/favorite-course", label: "Favorite Course" },
//         { to: "/find-tutors", label: "Find Best Tutors" },
//         { to: "/book-online-class", label: "Book Online Class" },
//       ],
//     },

//     {
//       label: "Blog",
//       links: [
//         { to: "/blog", label: "Blog Grid" },
//         { to: "/blog-list", label: "Blog List" },
//         { to: "/blog-classic", label: "Blog Classic" },
//         { to: "/blog-details", label: "Blog Details" },
//       ],
//     },
//     { to: "/contact", label: "Contact" },
//   ];

//   return (
//     <>
//       <div className={`side-overlay ${isMenuActive ? "show" : ""}`}></div>
//       <header className={`header ${scroll ? "fixed-header" : ""}`}>
//         <div className='container container--xl'>
//           <nav className='header-inner flex-between gap-8'>
//             <div className='header-content-wrapper flex-align flex-grow-1'>
//               {/* Logo Start */}
//               <div className='logo'>
//                 <Link to='/' className='link'>
//                   <img src='assets/images/logo/logo.png' alt='Logo' />
//                 </Link>
//               </div>
//               {/* Logo End  */}
//               {/* Select Start */}
//               <div className='d-sm-block d-none'>
//                 <div className='header-select border border-neutral-30 bg-main-25 rounded-pill position-relative'>
//                   <span className='select-icon position-absolute top-50 translate-middle-y inset-inline-start-0 z-1 ms-lg-4 ms-12 text-xl pointer-event-none d-flex'>
//                     <i className='ph-bold ph-squares-four' />
//                   </span>
//                   <select
//                     className='js-example-basic-single border-0'
//                     name='state'
//                     defaultValue='categories'
//                   >
//                     <option value={"Categories"}>Categories</option>
//                     <option value={"Design"}>Design</option>
//                     <option value={"Development"}>Development</option>
//                     <option value={"Architecture"}>Architecture</option>
//                     <option value={"Life Style"}>Life Style</option>
//                     <option value={"Data Science"}>Data Science</option>
//                     <option value={"Marketing"}>Marketing</option>
//                     <option value={"Music"}>Music</option>
//                     <option value={"Typography"}>Typography</option>
//                     <option value={"Finance"}>Finance</option>
//                     <option value={"Motivation"}>Motivation</option>
//                   </select>
//                 </div>
//               </div>
//               {/* Select End */}
//               {/* Menu Start  */}
//               <div className='header-menu d-lg-block d-none'>
//                 <ul className='nav-menu flex-align'>
//                   {menuItems.map((item, index) =>
//                     item.links ? (
//                       <li
//                         key={`menu-item-${index}`}
//                         className='nav-menu__item has-submenu'
//                       >
//                         <span to='#' className='nav-menu__link'>
//                           {item.label}
//                         </span>
//                         <ul className={`nav-submenu scroll-sm`}>
//                           {item.links.map((link, linkIndex) => (
//                             <li
//                               key={`submenu-item-${linkIndex}`}
//                               className={`nav-submenu__item ${
//                                 pathname === link.to && "activePage"
//                               }`}
//                             >
//                               <Link
//                                 to={link.to}
//                                 className='nav-submenu__link hover-bg-neutral-30'
//                               >
//                                 {link.label}
//                               </Link>
//                             </li>
//                           ))}
//                         </ul>
//                       </li>
//                     ) : (
//                       <li
//                         key={`menu-contact-${index}`}
//                         className={`nav-menu__item ${
//                           pathname === item.to && "activePage"
//                         }`}
//                       >
//                         <Link to={item.to} className='nav-menu__link'>
//                           {item.label}
//                         </Link>
//                       </li>
//                     )
//                   )}
//                 </ul>
//               </div>
//               {/* Menu End  */}
//             </div>
//             {/* Header Right start */}
//             <div className='header-right flex-align'>
//               <form
//                 action='#'
//                 className='search-form position-relative d-xl-block d-none'
//               >
//                 <input
//                   type='text'
//                   className='common-input rounded-pill bg-main-25 pe-48 border-neutral-30'
//                   placeholder='Search...'
//                 />
//                 <button
//                   type='submit'
//                   className='w-36 h-36 bg-main-600 hover-bg-main-700 rounded-circle flex-center text-md text-white position-absolute top-50 translate-middle-y inset-inline-end-0 me-8'
//                 >
//                   <i className='ph-bold ph-magnifying-glass' />
//                 </button>
//               </form>
//               <Link
//                 to='/sign-in'
//                 className='info-action w-52 h-52 bg-main-25 hover-bg-main-600 border border-neutral-30 rounded-circle flex-center text-2xl text-neutral-500 hover-text-white hover-border-main-600'
//               >
//                 <i className='ph ph-user-circle' />
//               </Link>
//               <button
//                 type='button'
//                 className='toggle-mobileMenu d-lg-none text-neutral-200 flex-center'
//                 onClick={toggleMenu}
//               >
//                 <i className='ph ph-list' />
//               </button>
//             </div>
//             {/* Header Right End  */}
//           </nav>
//         </div>
//       </header>

//       <div
//         className={`mobile-menu scroll-sm d-lg-none d-block ${
//           isMenuActive ? "active" : ""
//         }`}
//       >
//         <button type='button' className='close-button' onClick={closeMenu}>
//           <i className='ph ph-x' />{" "}
//         </button>
//         <div className='mobile-menu__inner'>
//           <Link to='/' className='mobile-menu__logo'>
//             <img src='assets/images/logo/logo.png' alt='Logo' />
//           </Link>
//           <div className='mobile-menu__menu'>
//             <ul className='nav-menu flex-align nav-menu--mobile'>
//               {menuItems.map((item, index) =>
//                 item.links ? (
//                   <li
//                     key={`menu-item-${index}`}
//                     className={`nav-menu__item has-submenu ${
//                       activeSubmenu === index ? "activePage" : ""
//                     }`}
//                     onClick={() => handleSubmenuClick(index)}
//                   >
//                     <span className='nav-menu__link'>{item.label}</span>
//                     <ul className={`nav-submenu scroll-sm`}>
//                       {item.links.map((link, linkIndex) => (
//                         <li key={linkIndex} className='nav-submenu__item'>
//                           <Link
//                             to={link.to}
//                             className='nav-submenu__link hover-bg-neutral-30'
//                           >
//                             {link.label}
//                           </Link>
//                         </li>
//                       ))}
//                     </ul>
//                   </li>
//                 ) : (
//                   <li
//                     className={`nav-menu__item ${
//                       pathname === item.to && "activePage"
//                     }`}
//                     key={index}
//                   >
//                     <Link to={item.to} className='nav-menu__link'>
//                       {item.label}
//                     </Link>
//                   </li>
//                 )
//               )}
//             </ul>
//             <div className='d-sm-none d-block mt-24'>
//               <div className='header-select mobile border border-neutral-30 bg-main-25 rounded-pill position-relative'>
//                 <span className='select-icon position-absolute top-50 translate-middle-y inset-inline-start-0 z-1 ms-lg-4 ms-12 text-xl pointer-event-none d-flex'>
//                   <i className='ph-bold ph-squares-four' />
//                 </span>
//                 <select
//                   className='js-example-basic-single border-0'
//                   name='state'
//                 >
//                   <option value={"Categories"}>Categories</option>
//                   <option value={"Design"}>Design</option>
//                   <option value={"Development"}>Development</option>
//                   <option value={"Architecture"}>Architecture</option>
//                   <option value={"Life Style"}>Life Style</option>
//                   <option value={"Data Science"}>Data Science</option>
//                   <option value={"Marketing"}>Marketing</option>
//                   <option value={"Music"}>Music</option>
//                   <option value={"Typography"}>Typography</option>
//                   <option value={"Finance"}>Finance</option>
//                   <option value={"Motivation"}>Motivation</option>
//                 </select>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default HeaderOne;
